import { render, staticRenderFns } from "./AIResource.vue?vue&type=template&id=1c7ca969"
import script from "./AIResource.vue?vue&type=script&lang=js"
export * from "./AIResource.vue?vue&type=script&lang=js"
import style0 from "./AIResource.vue?vue&type=style&index=0&id=1c7ca969&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports